import ProfilePreviewPdfSection from './ProfilePreviewPdfSection.component';

export default ProfilePreviewPdfSection;